import { render, staticRenderFns } from "./newfollow.vue?vue&type=template&id=13f857ea&scoped=true&"
import script from "./newfollow.vue?vue&type=script&lang=js&"
export * from "./newfollow.vue?vue&type=script&lang=js&"
import style0 from "./newfollow.vue?vue&type=style&index=0&id=13f857ea&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f857ea",
  null
  
)

export default component.exports